import React, {useEffect} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import {ROUTES} from "../../../../../routes";
import GroheQuotingToolIntro from "./groheQuotingToolIntro";
import GroheQuotingToolContent from "./groheQuotingToolContent";
import GroheQuotingToolSteps from "./groheQuotingToolSteps";
import GroheQuotingToolResult from "./groheQuotingToolResult";
import {getWizardSubParts} from "../groheFunctions";
import {setLookActiveCategory, setLookActiveFeature} from "../../../../../actions/lookFunctions";


const GroheQuotingTool = (props) => {

  const {lookPageOpened, wizardStep, wizardName, setLookActiveFeature, setLookActiveCategory, history, activePreset} = props;
  const layoutsOpened = lookPageOpened === ROUTES.wizard;
  const wizardSubParts = getWizardSubParts(wizardName);

  useEffect(() => {
    if(lookPageOpened === ROUTES.wizard && wizardStep >= 0 && wizardStep < wizardSubParts.length) {
      setLookActiveCategory(wizardSubParts[wizardStep].part.partId);
      setLookActiveFeature(wizardSubParts[wizardStep].part.activeFeature);
      // const lookId = getLookId(activePreset, bvPresets);
      // history.push(getFeatureUrl(lmFeature.cartFeature, true));
      // history.push(`${getLookIdUrl()}wizard/${wizardName.toLowerCase()}/${wizardStep}`);
    }
  }, [setLookActiveCategory, setLookActiveFeature, wizardSubParts, wizardStep, lookPageOpened, history, activePreset, wizardName])

  if (!wizardSubParts) {
    return null
  }

  const totalSteps = wizardSubParts.length + 1;

  return (
    <section className={"grohe-section" + (layoutsOpened ? " grohe-section--opened" : "")}>
      {wizardStep === -1 ? <div className="grohe-container grohe-container--no-top-padding"><GroheQuotingToolIntro/></div> : null}
      {wizardStep >= 0 && wizardStep < wizardSubParts.length ? <GroheQuotingToolContent subParts={wizardSubParts}/> : null}
      {wizardStep >= wizardSubParts.length ? <GroheQuotingToolResult subParts={wizardSubParts} totalSteps={totalSteps}/> : null }
      {wizardStep !== -1 ? <GroheQuotingToolSteps subParts={wizardSubParts} totalSteps={totalSteps}/> : null }
    </section>
  )
};

const mapStateToProps = (store) => {
  const {lookPageOpened} = store.lookState;
  const {wizardStep, wizardName} = store.groheQuotingToolState;
  const {activePreset} = store.bathroomVisualizerState;
  return {
    lookPageOpened,
    activePreset,
    wizardStep,
    wizardName,
  };
};

const mapDispatchToProps = {
  setLookActiveCategory,
  setLookActiveFeature
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheQuotingTool)
)
